<template>
    <div id="videocall">
        <div v-if="!remoteVideoEnabled" class="vcthumbnail">
            <a-avatar
                :size="100"
                :username="agentName()"
                style="background-color: rgb(49 50 52) !important; color: white; font-size: 25px"
                >{{ agentName().substr(0, 1).toUpperCase() }}
            </a-avatar>
        </div>
        <div v-if="dialingAgentNumber && !callStarted" class="calling">
            <div class="visitor-info">
                <div class="avatar">
                    <img :src="this.organizationLogo" class="avatar" />
                </div>
                <div class="user-name">
                    {{ agentName() }}<br />
                    <span>Arıyor...</span>
                </div>
            </div>
            <div class="callingToolbox">
                <md-button class="md-fab open-btn" @click.prevent="answer" :disabled="answering">
                    <md-icon style="color: white">call</md-icon>
                </md-button>
                <md-button class="md-fab close-btn" @click.prevent="reject" :disabled="answering">
                    <md-icon style="color: white">call_end</md-icon>
                </md-button>
            </div>
        </div>
        <div id="calling-screen" v-if="screenShareRequest" class="calling">
            <div class="visitor-info">
                <div class="avatar">
                    <img :src="this.organizationLogo" class="avatar" />
                </div>
                <div class="user-name">
                    {{ agentName() }}<br />
                    <span>Arıyor...</span>
                </div>
            </div>
            <div class="callingToolbox">
                <md-button class="md-fab open-btn" @click.prevent="acceptScreenShare">
                    <md-icon style="color: white">call</md-icon>
                </md-button>
                <md-button class="md-fab close-btn" @click.prevent="screenShareRequest = false">
                    <md-icon style="color: white">call_end</md-icon>
                </md-button>
            </div>
        </div>
        <div id="video_display" ref="video_display" key="video_display"></div>
        <div id="video_self" key="video_self"></div>
        <div v-if="callStarted" class="controlBox" :class="remoteVideoEnabled && isSoundOnly ? 'just-voice' : ''">
            <md-button
                v-if="remoteVideoEnabled && !isSoundOnly"
                class="md-icon-button md-primary callScreen-item"
                @click="!isFullScreen ? makeFullScreen() : closeFullScreen()"
            >
                <md-icon v-if="!isFullScreen">fullscreen</md-icon>
                <md-icon v-else>close_fullscreen</md-icon>
            </md-button>
            <md-button
                v-if="!isSoundOnly"
                class="md-icon-button md-primary play-sound-button callScreen-item"
                @click.prevent="toggleVideoCam"
            >
                <md-icon>{{ videoEnabled ? "videocam" : "videocam_off" }}</md-icon>
            </md-button>
            <md-button class="md-icon-button md-primary play-sound-button callScreen-item" @click.prevent="toggleMic">
                <md-icon>{{ micEnabled ? "mic" : "mic_off" }}</md-icon>
            </md-button>
            <md-button
                v-if="!isMobileDevice"
                class="md-icon-button md-primary play-sound-button callScreen-item"
                @click.prevent="shareScreen"
            >
                <md-icon style="color: teal">screen_share</md-icon>
            </md-button>
            <md-button
                v-if="isMultipleCamera"
                class="md-icon-button md-primary play-sound-button callScreen-item"
                @click.prevent="changeCamera"
            >
                <md-icon style="color: teal">cameraswitch</md-icon>
            </md-button>
            <div class="right-button">
                <md-button class="md-icon-button md-primary play-sound-button" @click.prevent="toggleVideoCall">
                    <md-icon class="swap" style="color: teal">swap_horiz</md-icon>
                </md-button>
                <md-button class="md-icon-button md-primary play-sound-button" @click.prevent="cancelVideoCall">
                    <md-icon style="color: red">cancel</md-icon>
                </md-button>
            </div>
        </div>
    </div>
</template>

<script>
import { log2 } from "../../utils/log2";
import { mapActions, mapMutations, mapState } from "vuex";
import { getVideoCall } from "../../webrtc/phoneSDK";
import { PHONE_UTILS } from "../../utils/phone";
import { sendSocketMessage, socketMessageStream } from "../../utils/socketStream";
import beep from "../../assets/media/calling.ogg";
import { filter, first, map } from "rxjs/operators";
import { systemMessageStream } from "../../utils/systemPubSub";
import { sendCommandToParentWindow } from "../../utils/parentWindowConnection";
import fscreen from "fscreen";

const log = log2("VideoCallScreen");
export default {
    name: "VideoCallScreen",
    components: {},
    props: {
        participants: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            screenShareStarted: false,
            screenShareRequest: false,
            subs: [],
            playAudio: new Audio(beep),
            timerIds: [],
            callStarted: false,
            isFullScreen: false,
            isMultipleCamera: false,
            isMobileDevice: false,
            isFrontCamera: true,
            answering: false,
            organizationLogo: null,
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            currentVC: (state) => state.app.currentVC,
            dialingAgentNumber: (state) => state.app.videoCallDialing,
            visitorId: (state) => state.chat.visitorId,
            chatAgents: (state) => state.chat.chatAgents,
            videoEnabled: (state) => state.webrtc.videoEnabled,
            micEnabled: (state) => state.webrtc.micEnabled,
            remoteMicEnabled: (state) => state.webrtc.remoteMicEnabled,
            remoteVideoEnabled: (state) => state.webrtc.remoteVideoEnabled,
            isSoundOnly: (state) => state.webrtc.isSoundOnly,
            isScreenOnly: (state) => state.webrtc.isScreenOnly,
            conversationId: (state) => state.chat.conversationId,
            settings: (state) => state.setting.settings,
        }),
    },
    methods: {
        ...mapActions({
            setVideoCallMode: "app/setVideoCallMode",
            setCalling: "app/setCalling",
            setVideoCall: "app/setVideoCall",
            setSoundOnly: "webrtc/setSoundOnly",
            closeConnection: "webrtc/closeConnection",
        }),
        ...mapMutations({
            mutRemoteVideoEnabled: "webrtc/SET_REMOTE_VIDEO_ENABLED",
            mutRemoteMicEnabled: "webrtc/SET_REMOTE_MIC_ENABLED",
        }),
        getOrganitazionLogo() {
            const asset = this.settings.organizationLogo;
            this.organizationLogo = this.participants[0].gravatar || asset.v2Format && asset.cdnUrl
            ? asset.cdnUrl
            :`https://static.supsis.live/${asset.path}${asset.id}.${asset.ext}`;
            return;
        },
        makeFullScreen() {
            const elem = document.getElementById("videocall");
            log("is full screen supported ", {
                isSupported: fscreen.fullscreenEnabled,
                childs: this.$refs.video_display.childNodes[0],
            });
            const maybeElem = this.$refs.video_display.childNodes[0];
            if (maybeElem) {
                maybeElem.style.height = "100%";
            }
            fscreen.requestFullscreen(elem);
        },
        closeFullScreen() {
            const maybeElem = this.$refs.video_display.childNodes[0];
            if (maybeElem) {
                maybeElem.style.height = "63vh";
            }
            fscreen.exitFullscreen();
        },
        acceptScreenShare() {
            this.screenShareRequest = false;
            this.startScreenSharing();
        },
        async answer() {
            if (!this.dialingAgentNumber) {
                log.error("answer error , dialingAgentNumber must not be null");
                return;
            }
            this.answering = true;
            sendSocketMessage("visitor video-call-accepted", {
                siteId: this.site._id,
                visitorId: this.visitorId,
                userId: this.dialingAgentNumber,
                conversationId: this.conversationId,
                isSoundOnly: this.isSoundOnly,
            });

            const phone = PHONE_UTILS.getPhone();

            phone.camera.start();

            phone.dial(this.dialingAgentNumber, null, "VCS");
            let isConnected = await systemMessageStream
                .pipe(
                    filter((x) => x.type === "videocall-success"),
                    map((x) => x.payload),
                    first()
                )
                .toPromise();
            if (isConnected) {
                sendSocketMessage("visitor video-call-success", {
                    siteId: this.site._id,
                    visitorId: this.visitorId,
                    userId: this.currentVC,
                    conversationId: this.conversationId,
                    isSoundOnly: this.isSoundOnly,
                });
                this.mountVideo();
                if (!this.isSoundOnly) {
                    sendCommandToParentWindow("wide-visitor-screen", true);
                    this.getVideoDevices();
                } else {
                    const maybeElem = this.$refs.video_display.childNodes[0];
                    if (maybeElem) {
                        maybeElem.style.height = "15vh";
                        maybeElem.style.backgroundColor = "#FFF";
                    }
                }
                this.callStarted = true;
            }
        },
        getVideoDevices() {
            navigator.mediaDevices.enumerateDevices().then((devices) => {
                const videoDevices = devices.filter((device) => device.kind === "videoinput");
                if (videoDevices.length > 1) {
                    this.isMultipleCamera = true;
                }
            });
        },
        reject() {
            sendSocketMessage("visitor video-call-rejected", {
                siteId: this.site._id,
                visitorId: this.visitorId,
                userId: this.dialingAgentNumber,
                conversationId: this.conversationId,
            });
            this.setCalling(null);
            this.setVideoCall(null);
            const phone = PHONE_UTILS.getPhone();
            if (phone) {
                phone.camera.stop();
                phone.screen.stop();
                phone.hangup();
            }
            this.closeConnection();
            this.setVideoCallMode(false);
        },
        agentName() {
            if (this.chatAgents) {
                const name = this.chatAgents[0].name;
                return name || this.$t("message.representative");
            }
        },
        toggleMic() {
            const phone = PHONE_UTILS.getPhone();
            phone.camera.toggleAudio();
        },
        toggleVideoCam() {
            const phone = PHONE_UTILS.getPhone();
            const data = {
                siteId: this.site._id,
                visitorId: this.visitorId,
                userId: this.dialingAgentNumber,
                conversationId: this.conversationId,
            };
            phone.camera.toggleVideo(data);
        },
        shareScreen() {
            this.startScreenSharing();
        },
        toggleVideoCall() {
            const videocall = document.getElementById("videocall");
            const videoSelf = document.getElementById("video_self");
            if (videoSelf.style.display === "none") {
                videocall.style.height = "calc(100vh - 80px)";
                videocall.classList.remove("chatScreen");
                videocall.classList.add("callScreen");
                videoSelf.style.display = "block";
            } else {
                videocall.style.height = "calc(100vh - 400px)";
                videocall.classList.add("chatScreen");
                videocall.classList.remove("callScreen");
                videoSelf.style.display = "none";
            }
        },
        cancelVideoCall(signal = true) {
            log("cancelVideoCall", signal);
            let phone = PHONE_UTILS.getPhone();
            if (phone) {
                phone.camera.stop();
                phone.screen.stop();
                phone.hangup();
            }

            if (signal)
                sendSocketMessage("visitor video-call-close", {
                    siteId: this.site._id,
                    visitorId: this.visitorId,
                    userId: this.currentVC,
                    conversationId: this.conversationId,
                    sendMessage: signal,
                    isSoundOnly: this.isSoundOnly,
                });
            this.setVideoCall(null);
            this.closeConnection();
            this.callStarted = false;
            sendCommandToParentWindow("wide-visitor-screen", false);
            this.setVideoCallMode(false);
        },
        async startScreenSharing() {
            if (this.screenShareStarted) return;
            this.screenShareStarted = true;
            log("startScreenSharing called");
            let phone = PHONE_UTILS.getPhone();
            const screenVideo = await phone.screen.start();

            if (screenVideo && !this.isSoundOnly) {
                const video_self = document.getElementById("video_self");
                log("camera received 1", screenVideo);
                video_self.innerHTML = "";
                video_self.appendChild(screenVideo);
            } else this.screenShareStarted = this.isSoundOnly;
            sendSocketMessage("visitor screen-share", {
                siteId: this.site._id,
                userId: this.currentVC,
                isStartCall: true,
                soundOnly: this.isSoundOnly,
            });
        },
        async changeCamera() {
            log("changeCamera called");
            let phone = PHONE_UTILS.getPhone();
            phone.camera.changeCamera(!this.isFrontCamera).then((x) => {
                this.isFrontCamera = !this.isFrontCamera;
            });
        },
        mountVideo() {
            log("currentVC changed", this.currentVC);
            const phone = PHONE_UTILS.getPhone();
            if (this.currentVC) {
                const video_out = document.getElementById("video_display");
                const video_self = document.getElementById("video_self");
                const vc = getVideoCall(this.currentVC);
                video_out.innerHTML = "";
                log("mounted", vc);
                const myVideo = phone.camera.video();
                if (myVideo && !this.isSoundOnly) {
                    log("camera received 1");
                    log("appending 1");
                    video_self.innerHTML = "";
                    video_self.appendChild(myVideo);
                }
                if (!this.isSoundOnly) {
                    phone.camera((v) => {
                        log("camera received2", v);
                        video_self.innerHTML = "";
                        video_self.appendChild(v);
                    });
                }
                if (!this.isSoundOnly) {
                    vc.connected((session) => {
                        this.mutRemoteVideoEnabled(true);
                        log("remote connected", session.video);
                        video_out.innerHTML = "";
                        video_out.appendChild(session.video);
                    });
                }
            }
        },
    },
    watch: {
        participants() {
            this.getOrganitazionLogo();
            this.agentName();
        },
        currentVC(vcNumber) {
            if (vcNumber) {
                this.mountVideo();
            }
        },
        dialingAgentNumber(newValue) {
            log("dialingAgentNumber agent number", newValue);
            if (!newValue) {
                this.playAudio.pause();
            }
        },
        callStarted(newValue) {
            if (newValue) this.playAudio.pause();
        },
    },

    mounted() {
        let sub = socketMessageStream.pipe(filter((x) => x.cmd === "video_call_screen_share_request")).subscribe(() => {
            if (!this.screenShareStarted) {
                this.screenShareRequest = true;
                let interval1 = setTimeout(() => {
                    if (this.screenShareRequest) {
                        this.screenShareRequest = false;
                    }
                }, 1000 * 30);
                this.timerIds.push(interval1);
            }
        });

        let sub3 = systemMessageStream
            .pipe(filter((x) => x.type === "screen_share_ended"))
            .subscribe(() => (this.screenShareStarted = false));

        let cancelSub = systemMessageStream
            .pipe(
                filter((x) => x.type === "vc_ended"),
                first()
            )
            .subscribe((x) => {
                log("vc_ended received");
                this.cancelVideoCall(x.payload.signal);
            });
        this.subs.push(sub);
        this.subs.push(sub3);
        this.subs.push(cancelSub);
        log("dialingAgentNumber agent number", this.dialingAgentNumber);
        if (typeof this.playAudio.loop == "boolean") {
            this.playAudio.loop = true;
        } else {
            this.playAudio.addEventListener(
                "ended",
                function () {
                    this.currentTime = 0;
                    this.play();
                },
                false
            );
        }
        this.playAudio.play();
        let interval2 = setTimeout(() => {
            if (!this.callStarted) {
                this.reject();
            }
        }, 1000 * 45);
        this.timerIds.push(interval2);
        if (fscreen.fullscreenEnabled) {
            fscreen.addEventListener("fullscreenchange", () => {
                if (fscreen.fullscreenElement !== null) {
                    log("Entered fullscreen mode");
                    this.isFullScreen = true;
                } else {
                    log("Exited fullscreen mode");
                    this.isFullScreen = false;
                }
            });
        }
        this.isMobileDevice = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    },
    beforeDestroy() {
        this.subs.forEach((x) => x.unsubscribe());
        log("dialingAgentNumber agent number destroy", this.dialingAgentNumber);
        this.callStarted = false;
        this.playAudio.pause();
        this.timerIds.forEach((x) => {
            clearInterval(x);
        });
    },
};
</script>

<style lang="scss">
#videocall {
    position: absolute;
    /* margin: 0 auto; */
    z-index: 99;
    width: 100%;
    height: calc(100vh - 80px);
    min-height: 90px;
    top: 70px;

    .vcthumbnail {
        z-index: 999;
        position: absolute;
        border-radius: var(--sps-radius-lg);
        top: 50%;
        left: 50%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
    }

    .calling {
        z-index: 999;
        position: absolute;
        background-color: var(--background-color-first);
        border-radius: 8px 8px 0 0;
        width: 100%;
        padding: 50px 30px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        height: calc(100vh - 70px);

        .visitor-info {
            display: contents;
            text-align: center;

            .avatar {
                width: 100px;
                height: 100px;
                border-radius: var(--sps-radius-pill);
                border: 3px solid #ec4b1d;
                overflow: hidden;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    object-position: center;
                    border: none;
                }
            }

            .user-name {
                font-size: 32px;
                font-weight: 400;
                line-height: 48px;

                span {
                    font-size: 18px;
                    font-weight: 400;
                    line-height: 27px;
                }
            }
        }

        p.vc-calling {
            text-align: center;
            margin: 40px 0;
        }

        .callingToolbox {
            display: flex;
            justify-content: center;

            .open-btn {
                margin-right: 80px;
                background-color: #0bba18 !important;

                &:after {
                    content: "";
                    display: block;
                    border: 8px solid #fff;
                    border-radius: 50%;
                    width: 60px;
                    height: 60px;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    opacity: 1;
                    transform: translate(-50%, -50%) scale(0);
                    animation: pulsate 1s ease-out infinite;
                }

                @keyframes pulsate {
                    0% {
                        transform: translate(-50%, -50%) scale(0);
                        opacity: 0;
                    }
                    25% {
                        opacity: 1;
                    }
                    50% {
                        opacity: 0;
                    }
                    75% {
                        opacity: 1;
                    }
                    100% {
                        transform: translate(-50%, -50%) scale(1.5);
                        opacity: 0;
                    }
                }
            }

            .close-btn {
                background-color: #ec4b1d !important;
            }
        }
    }

    #video_display {
        width: 100%;
        height: 100%;

        video {
            width: 100%;
            height: calc(100vh - 125px);
            object-fit: cover;
            //object-fit: fill;
        }
    }

    #video_self {
        width: 150px;
        bottom: 55px;
        position: absolute;
        border: 2px solid #fff;
        right: 8px;
        border-radius: var(--sps-radius-md);
        overflow: hidden;

        video {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .controlBox {
        display: flex;
        width: 100%;
        // justify-content: center;
        position: absolute;
        bottom: 4px;
        border-radius: var(--sps-radius-sm);
        background-color: white;
        // left: 10px;
        &.just-voice {
            top: 0;
            box-shadow: 0px 0px 15px -3px rgba(0, 0, 0, 0.1);
            height: 40px;
        }
        .right-button {
            width: 100%;
            display: flex;
            justify-content: end;
        }
    }
    .header {
        position: absolute;
        left: 2px;
        top: 45px;

        z-index: 9999;

        .videocall-btn {
            background-color: transparent;
            border: none;

            &:hover {
                border-radius: 40%;
                background-color: rgba(0, 0, 0, 0.3);
            }
        }

        .move-cursor {
            cursor: move;
        }
    }
    &.chatScreen {
        #video_display {
            width: 150px;
            bottom: 7px;
            position: absolute;
            border: 2px solid #fff;
            right: 8px;
            border-radius: var(--sps-radius-md);
            overflow: hidden;
            video {
                width: 150px;
                height: 100%;
            }
        }
        .controlBox {
            right: 10px;
            left: unset;
            background-color: transparent;
            i {
                &.swap {
                    background-color: white;
                    border-radius: 50%;
                    width: 20px;
                    min-width: 20px;
                    height: 20px;
                }
            }
            button {
                width: 30px;
                min-width: 30px;
                margin: 0;
                &.callScreen-item {
                    display: none;
                }
            }
        }
    }
}

.md-fab {
    width: 65px !important;
    height: 65px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/V2/VideoCallScreen.vue